import { useSelector } from 'react-redux'

import { isLiteRetailer as isLiteRetailerSelector } from 'store/currentUser/selectors'

import { useHasVAAccess } from '../api/hooks/queries/useHasVAAccess'

/**
 * Whether to pitch Visual Assortment to the acting user: a Lite Retailer who is
 * not already using it. Visual Assortment is a Lite Retailer feature, so no
 * other account type is ever offered it — and a skipped access query answers
 * all-false, which on its own would read as "offer it".
 *
 * `isAccessInitialized && hasUserAccess` means the assortment exists and this
 * user is on it. Not `hasVAAccess`, which is true exactly when no assortment
 * exists yet — the users the offer targets. False while the query is in flight,
 * so an account that already uses Visual Assortment never sees the offer flash.
 */
export const useShouldOfferVA = () => {
  const isLiteRetailer = useSelector(isLiteRetailerSelector)
  const { hasUserAccess, isAccessInitialized, loading } = useHasVAAccess()

  return isLiteRetailer && !loading && !(isAccessInitialized && hasUserAccess)
}
